import { parseResponseData, publicAPI } from "@/shared/lib";
import { questionSchema } from "@/shared/models";
import type { Question } from "@/shared/models";

export const getInitialQuestion = async (bmi?: number) => {
  const response = await publicAPI.get(`/answer-groups/?bmi=${bmi}`);

  return parseResponseData(response, questionSchema);
};

export const getQuestion = async (questionId: Question["id"]) => {
  const response = await publicAPI.get(`/answer-groups/${questionId}`);

  return parseResponseData(response, questionSchema);
};
